// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3PooZ","buttons":"PendingPaymentAlert_buttons__26FkM"};